/* =============================================================
   IN HAIRCARE — Prix sur bouton Ajouter au panier (CTA + sticky)
   Self-contained, no theme edit beyond inclusion in theme.liquid.
   ============================================================= */
(function () {
  'use strict';

  // ---- Configuration ----------------------------------------------------
  var SEP            = ' — ';                 // em-dash
  var TXT_MAIN       = 'Ajouter au panier';
  var TXT_STICKY     = 'AJOUTER AU PANIER';
  var TXT_SOLDOUT    = 'Épuisé';
  var TXT_SOLDOUT_UC = 'ÉPUISÉ';

  // ---- Utility ----------------------------------------------------------
  function parsePrice(txt) {
    if (!txt) return null;
    // Strip everything except digits, comma, dot
    var s = String(txt).replace(/[^0-9,.\s]/g, '').trim();
    // Remove thousand separators (space, NBSP, NNBSP)
    s = s.replace(/[\s\u00A0\u202F]/g, '');
    // French uses ',' as decimal — convert to '.'
    if (s.indexOf(',') !== -1 && s.lastIndexOf(',') > s.lastIndexOf('.')) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else {
      s = s.replace(/,/g, '');
    }
    var n = parseFloat(s);
    return isNaN(n) ? null : n;
  }

  function fmtEUR(n) {
    if (n == null || isNaN(n)) return '';
    var fixed = (Math.round(n * 100) / 100).toFixed(2);
    return fixed.replace('.', ',') + ' €';
  }

  // ---- Locate the price block on the active product --------------------
  function getProductInfoRoot() {
    return document.querySelector('product-info, .product__info-container, [data-product-info]');
  }

  function getQuantity() {
    var root = getProductInfoRoot();
    if (!root) return 1;
    var qty = root.querySelector('input[name="quantity"]');
    if (!qty) qty = document.querySelector('input[name="quantity"]');
    if (!qty) return 1;
    var n = parseInt(qty.value, 10);
    return (isNaN(n) || n < 1) ? 1 : n;
  }

  // Cached current variant — kept in sync via PUB_SUB_EVENTS.variantChange.
  // Sourced from the JSON Shopify ships in <variant-selects [data-selected-variant]>.
  var CURRENT_VARIANT = null;
  var SUBSCRIPTION_DISCOUNT = 0.10; // 10% off when subscription is active

  function readVariantFromDOM() {
    var root = getProductInfoRoot();
    if (!root) return null;
    var node = root.querySelector('variant-selects [data-selected-variant]');
    if (!node || !node.textContent) return null;
    try {
      var v = JSON.parse(node.textContent);
      return (v && typeof v === 'object') ? v : null;
    } catch (e) {
      return null;
    }
  }

  function isSubscriptionActive() {
    // The custom subscription widget exposes its checkbox via `.sub-widget__checkbox`.
    // If no widget exists on the page (non-Recharge product), no discount is applied.
    var cb = document.querySelector('.sub-widget__checkbox');
    return !!(cb && cb.checked);
  }

  // Returns prices in EUROS as floats (variant data is in cents).
  // Falls back to DOM scraping only if no variant JSON is available — keeps
  // products that don't ship a `data-selected-variant` script working.
  function getPrices() {
    // Prefer fresh DOM read — Shopify's section-rendering keeps it in sync with
    // the live variant. Fall back to the cached pubsub variant if DOM read fails.
    var v = readVariantFromDOM() || CURRENT_VARIANT;
    if (v && typeof v.price === 'number') {
      CURRENT_VARIANT = v;
      var price = v.price / 100;
      var compareAt = (typeof v.compare_at_price === 'number' && v.compare_at_price > v.price)
        ? v.compare_at_price / 100
        : null;

      if (isSubscriptionActive()) {
        // Subscriber sees: discounted price as the live price, original variant price as strikethrough.
        var discounted = price * (1 - SUBSCRIPTION_DISCOUNT);
        return { price: discounted, compareAt: price };
      }
      return { price: price, compareAt: compareAt };
    }

    // ---- Fallback: scrape DOM (legacy path, last resort) ----
    var root = getProductInfoRoot();
    if (!root) return null;
    var salePriceEl    = root.querySelector('.price__sale .price-item--sale price-money');
    var compareEl      = root.querySelector('.price__sale s.price-item--regular price-money');
    var regularPriceEl = root.querySelector('.price__regular .price-item--regular price-money');
    var salePrice    = salePriceEl    ? parsePrice(salePriceEl.textContent)    : null;
    var comparePrice = compareEl      ? parsePrice(compareEl.textContent)      : null;
    var regularPrice = regularPriceEl ? parsePrice(regularPriceEl.textContent) : null;
    var isOnSale = comparePrice != null && comparePrice > 0;
    return isOnSale
      ? { price: salePrice != null ? salePrice : regularPrice, compareAt: comparePrice }
      : { price: regularPrice != null ? regularPrice : salePrice, compareAt: null };
  }

  // ---- Build the price markup that will be appended to button labels ---
  // Shows only the final (current) price — no strikethrough compare-at on the button.
  function buildPriceHTML(prices, qty) {
    if (!prices || prices.price == null) return '';
    var total = prices.price * qty;

    var html = '<span class="inh-cta-price-sep" aria-hidden="true">' + SEP + '</span>';
    html += '<span class="inh-cta-price">';
    html += '<span class="inh-cta-price-current">' + fmtEUR(total) + '</span>';
    html += '</span>';
    return html;
  }

  // ---- Apply to the buttons -------------------------------------------
  // Cached HTML of the cart bag icon — captured once, re-injected on every
  // update so it survives the theme's variant-change re-render (which strips
  // the `.button-with-icon__icon` span).
  var ICON_HTML_CACHE = null;
  function captureMainButtonIcon() {
    if (ICON_HTML_CACHE) return;
    var iconEl = document.querySelector(
      'button[name="add"].product-form__submit .button-with-icon__icon'
    );
    if (iconEl) ICON_HTML_CACHE = iconEl.outerHTML;
  }

  // Update the MAIN CTA button — writes directly into `.button-with-icon`
  // (always present), so it doesn't break when the theme re-renders the
  // button with a flatter structure on variant change.
  function updateMainButton(prices, qty) {
    var root = getProductInfoRoot();
    if (!root) return;
    var btn = root.querySelector('button[name="add"].product-form__submit');
    if (!btn) return;
    var wrapper = btn.querySelector('.button-with-icon');
    if (!wrapper) return;

    var isSoldOut = !!(btn.disabled || /épuisé|sold ?out|indispon/i.test(btn.textContent || ''));
    var label = isSoldOut ? TXT_SOLDOUT : TXT_MAIN;

    var priceHTML  = buildPriceHTML(prices, qty);
    var labelInner = '<span class="inh-cta-label">' + label + priceHTML + '</span>';
    var iconHTML   = ICON_HTML_CACHE || '';

    wrapper.innerHTML = labelInner + iconHTML;
  }

  // Update the STICKY CTA — its icon is in a sibling span outside the text
  // span, so we just rewrite the text span content.
  function updateStickyButton(prices, qty) {
    var textSpan = document.querySelector('.mobile-pdp-sticky-cta__button-text');
    if (!textSpan) return;

    var btn = textSpan.closest('button');
    var isSoldOut = !!(btn && (btn.disabled || /épuisé|sold ?out|indispon/i.test(btn.textContent || '')));
    var label = isSoldOut ? TXT_SOLDOUT_UC : TXT_STICKY;

    var priceHTML = buildPriceHTML(prices, qty);
    textSpan.innerHTML = label + priceHTML;
  }

  // Re-entrancy guard so our own DOM writes don't re-trigger the observer
  var isWriting = false;
  function updateAllButtons() {
    var prices = getPrices();
    var qty    = getQuantity();
    if (!getProductInfoRoot()) return;
    isWriting = true;
    try {
      updateMainButton(prices, qty);
      updateStickyButton(prices, qty);
    } finally {
      // Release on next tick — give the observer time to flush our own mutations
      setTimeout(function () { isWriting = false; }, 0);
    }
  }

  // ---- Inject minimal CSS for the price portion ------------------------
  function injectStyles() {
    if (document.getElementById('inh-cta-price-style')) return;
    var s = document.createElement('style');
    s.id = 'inh-cta-price-style';
    s.textContent =
      // ===== CTA Add-to-cart with price =====
      '.product-form__submit,.mobile-pdp-sticky-cta__button{white-space:normal;line-height:1.2;}' +
      '.product-form__submit .button-with-icon{display:inline-flex;align-items:center;gap:.5em;justify-content:center;flex-wrap:wrap;}' +
      '.inh-cta-label,' +
      '.mobile-pdp-sticky-cta__button-text{display:inline-flex;align-items:baseline;gap:.25em;flex-wrap:wrap;justify-content:center;}' +
      '.inh-cta-price-sep{opacity:.85;margin:0 .15em;}' +
      '.inh-cta-price{display:inline-flex;align-items:baseline;gap:.35em;white-space:nowrap;}' +
      '.inh-cta-price-compare{opacity:.7;text-decoration:line-through;font-weight:400;font-size:.85em;}' +
      '.inh-cta-price-current{font-weight:inherit;}' +
      '@media (max-width:480px){' +
        '.product-form__submit .inh-cta-price,' +
        '.mobile-pdp-sticky-cta__button-text .inh-cta-price{font-size:.95em;}' +
      '}' +
      // ===== Frequently Bought Together — single-line layout =====
      // Use !important everywhere so we win against the FBT app's stylesheet
      '.cbb-frequently-bought-container .cbb-frequently-bought-selector-list{list-style:none !important;padding:0 !important;margin:0 !important;}' +
      '.cbb-frequently-bought-container .cbb-frequently-bought-selector-list > li{' +
        'display:flex !important;align-items:center !important;gap:.5em !important;' +
        'flex-wrap:nowrap !important;flex-direction:row !important;width:100% !important;' +
        'margin:0 !important;padding:.4em 0 !important;min-width:0 !important;' +
      '}' +
      '.cbb-frequently-bought-container .cbb-frequently-bought-selector-list > li > .cbb-frequently-bought-selector-input{' +
        'flex:0 0 auto !important;margin:0 !important;width:auto !important;' +
      '}' +
      '.cbb-frequently-bought-container .cbb-frequently-bought-selector-list > li > span.translatable,' +
      '.cbb-frequently-bought-container .cbb-frequently-bought-selector-list > li > a.cbb-frequently-bought-selector-link{' +
        'flex:1 1 auto !important;min-width:0 !important;max-width:100% !important;' +
        'overflow:hidden !important;display:block !important;' +
      '}' +
      '.cbb-frequently-bought-container .cbb-frequently-bought-selector-list .cbb-frequently-bought-selector-label-name{' +
        'display:block !important;margin:0 !important;font-size:1em !important;font-weight:500 !important;line-height:1.25 !important;' +
        'overflow:hidden !important;text-overflow:ellipsis !important;white-space:nowrap !important;' +
        'max-width:100% !important;' +
      '}' +
      '.cbb-frequently-bought-container .cbb-frequently-bought-selector-list a.cbb-frequently-bought-selector-link{' +
        'overflow:hidden !important;text-overflow:ellipsis !important;white-space:nowrap !important;' +
      '}' +
      // Hide the "Cet article :" prefix
      '.cbb-frequently-bought-this-item-label{display:none !important;}' +
      // Prices group on the right, never wrap
      '.cbb-frequently-bought-container .cbb-frequently-bought-selector-list > li > .cbb-frequently-bought-selector-label-compare-at-price,' +
      '.cbb-frequently-bought-container .cbb-frequently-bought-selector-list > li > .cbb-frequently-bought-selector-label-regular-price,' +
      '.cbb-frequently-bought-container .cbb-frequently-bought-selector-list > li > .cbb-frequently-bought-selector-label-sale-price{' +
        'flex:0 0 auto !important;white-space:nowrap !important;margin-left:auto !important;' +
      '}' +
      // Compare price (strikethrough): keep it visually grouped with the sale/regular
      '.cbb-frequently-bought-container .cbb-frequently-bought-selector-list > li > .cbb-frequently-bought-selector-label-compare-at-price{' +
        'margin-left:auto !important;font-size:.9em !important;opacity:.7 !important;' +
      '}' +
      '.cbb-frequently-bought-container .cbb-frequently-bought-selector-list > li > .cbb-frequently-bought-selector-label-compare-at-price + .cbb-frequently-bought-selector-label-regular-price,' +
      '.cbb-frequently-bought-container .cbb-frequently-bought-selector-list > li > .cbb-frequently-bought-selector-label-compare-at-price + .cbb-frequently-bought-selector-label-sale-price{' +
        'margin-left:.4em !important;' +
      '}' +
      '@media (max-width:480px){' +
        '.cbb-frequently-bought-container .cbb-frequently-bought-selector-list .cbb-frequently-bought-selector-label-name{font-size:.92em !important;}' +
        '.cbb-frequently-bought-container .cbb-frequently-bought-selector-list > li > .cbb-frequently-bought-selector-label-regular-price,' +
        '.cbb-frequently-bought-container .cbb-frequently-bought-selector-list > li > .cbb-frequently-bought-selector-label-sale-price{font-size:.95em !important;}' +
      '}';
    document.head.appendChild(s);
  }

  // ---- FBT (Frequently Bought Together) re-trigger watcher ------------
  // The CodeBlackBelt FBT app injects its block client-side into
  // #pdp-fbq-show-here. When the theme re-renders <product-info> on variant
  // change, the new HTML from Shopify's Section Rendering API contains only
  // the empty placeholder, so the box vanishes.
  //
  // Fix: detect the empty placeholder and re-trigger the app via its public
  // API: `window.codeblackbelt['frequently-bought-togetherApi'].restartCallback()`
  // The app destroys its previous instance and re-injects the box with
  // properly bound handlers (checkboxes, "Add to cart" button).
  function getFBTPlaceholder() {
    return document.querySelector('#pdp-fbq-show-here');
  }

  function getFBTApi() {
    var ns = window.codeblackbelt;
    if (!ns) return null;
    return ns['frequently-bought-togetherApi'] || null;
  }

  function restartFBTApp() {
    var api = getFBTApi();
    if (!api || typeof api.restartCallback !== 'function') return false;
    try {
      var fn = api.restartCallback();
      if (typeof fn === 'function') fn();
      return true;
    } catch (e) {
      return false;
    }
  }

  // If we ever need to retry once the API isn't loaded yet
  var FBT_RESTART_PENDING = false;
  function scheduleRestartFBT() {
    if (FBT_RESTART_PENDING) return;
    FBT_RESTART_PENDING = true;
    var attempts = 0;
    var maxAttempts = 12; // ~6 s total
    var tick = function () {
      var ph = getFBTPlaceholder();
      if (!ph) { FBT_RESTART_PENDING = false; return; }
      // Already populated → nothing to do
      if (ph.querySelector('.cbb-frequently-bought-container')) {
        FBT_RESTART_PENDING = false;
        return;
      }
      // Empty → try restart
      if (restartFBTApp()) {
        FBT_RESTART_PENDING = false;
        return;
      }
      // Otherwise retry until API becomes available
      attempts++;
      if (attempts < maxAttempts) {
        setTimeout(tick, 500);
      } else {
        FBT_RESTART_PENDING = false;
      }
    };
    tick();
  }

  function initFBTWatcher() {
    var initialPlaceholder = getFBTPlaceholder();
    if (!initialPlaceholder) return; // No FBT on this page

    // Watch <product-info> for re-renders that wipe the FBT placeholder
    var pi = getProductInfoRoot();
    if (!pi) return;
    var debounce = null;
    new MutationObserver(function () {
      if (debounce) clearTimeout(debounce);
      debounce = setTimeout(function () {
        var ph = getFBTPlaceholder();
        if (!ph) return;
        if (ph.querySelector('.cbb-frequently-bought-container')) return;
        scheduleRestartFBT();
      }, 200);
    }).observe(pi, { childList: true, subtree: true });
  }

  // ---- Observe DOM for variant-change re-renders -----------------------
  var debounceTimer = null;
  function scheduleUpdate() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(updateAllButtons, 30);
  }

  function observeMutations() {
    var root = getProductInfoRoot();
    if (!root) return;

    // Re-render on any subtree change (variant fetch replaces the price block)
    var mo = new MutationObserver(function (mutations) {
      // Don't react to our own DOM writes
      if (isWriting) return;
      // Skip mutations entirely contained inside our injected markup
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (!t || !t.closest) continue;
        if (t.closest('.inh-cta-price, .inh-cta-price-sep, .inh-cta-label')) continue;
        scheduleUpdate();
        return;
      }
    });
    mo.observe(root, { childList: true, subtree: true, characterData: true });
  }

  // ---- Init ------------------------------------------------------------
  // ---- Delivery date calculator ----------------------------------------
  // Replaces .delivery-note (injected by a 3rd-party app) with a dynamic
  // calculation based on the In Haircare cutoff rule:
  //   - Order before 13h30 Paris time → delivered J+1
  //   - Order after  13h30 Paris time → delivered J+2
  //   - Skip Sundays and French public holidays
  //   - Display range = first delivery day → next delivery day after that
  //   - Countdown frozen at page load, points to next 13h30 cutoff

  var FR_HOLIDAYS_CACHE = {};

  function easter(year) {
    // Anonymous Gregorian algorithm — returns Easter Sunday
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }

  function dateKey(d) {
    return d.getFullYear() + '-' +
           String(d.getMonth() + 1).padStart(2, '0') + '-' +
           String(d.getDate()).padStart(2, '0');
  }

  function frHolidaysForYear(year) {
    if (FR_HOLIDAYS_CACHE[year]) return FR_HOLIDAYS_CACHE[year];
    var easterSun = easter(year);
    var easterMon = new Date(easterSun); easterMon.setDate(easterMon.getDate() + 1);
    var ascension = new Date(easterSun); ascension.setDate(ascension.getDate() + 39);
    var pentecote = new Date(easterSun); pentecote.setDate(pentecote.getDate() + 50);
    var holidays = {};
    [
      new Date(year, 0, 1),    // 1er janvier
      easterMon,               // Lundi de Pâques
      new Date(year, 4, 1),    // 1er mai
      new Date(year, 4, 8),    // 8 mai
      ascension,               // Ascension
      pentecote,               // Lundi de Pentecôte
      new Date(year, 6, 14),   // 14 juillet
      new Date(year, 7, 15),   // 15 août
      new Date(year, 10, 1),   // 1er novembre
      new Date(year, 10, 11),  // 11 novembre
      new Date(year, 11, 25)   // 25 décembre
    ].forEach(function (d) { holidays[dateKey(d)] = true; });
    FR_HOLIDAYS_CACHE[year] = holidays;
    return holidays;
  }

  function isDeliveryDay(date) {
    if (date.getDay() === 0) return false; // Sunday
    var holidays = frHolidaysForYear(date.getFullYear());
    return !holidays[dateKey(date)];
  }

  function nextDeliveryDayStrict(date) {
    var d = new Date(date);
    d.setDate(d.getDate() + 1);
    while (!isDeliveryDay(d)) d.setDate(d.getDate() + 1);
    return d;
  }

  // Returns Date object representing "now" with Paris-time field values
  // (year/month/day/hour/min). Local TZ wrapping is irrelevant since we
  // only use day-arithmetic and hour comparisons after this.
  function nowAsParisDate() {
    var fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    });
    var parts = fmt.formatToParts(new Date());
    var get = function (t) { return parseInt((parts.find(function (p) { return p.type === t; }) || {}).value, 10); };
    return new Date(get('year'), get('month') - 1, get('day'), get('hour') === 24 ? 0 : get('hour'), get('minute'), get('second'));
  }

  function calculateDeliveryRange() {
    var now = nowAsParisDate();
    var cutoffToday = new Date(now); cutoffToday.setHours(13, 30, 0, 0);
    var afterCutoff = now.getTime() >= cutoffToday.getTime();

    // First valid delivery day: J+1 if before cutoff, J+2 otherwise
    // (skipping non-delivery days like Sundays/holidays as we go)
    var startDate = nextDeliveryDayStrict(now);
    if (afterCutoff) startDate = nextDeliveryDayStrict(startDate);
    var endDate = nextDeliveryDayStrict(startDate);

    // Countdown to the next 13h30 cutoff
    var nextCutoff = new Date(now); nextCutoff.setHours(13, 30, 0, 0);
    if (afterCutoff) nextCutoff.setDate(nextCutoff.getDate() + 1);
    var msUntil = Math.max(0, nextCutoff.getTime() - now.getTime());
    var totalMin = Math.floor(msUntil / 60000);
    var hours = Math.floor(totalMin / 60);
    var minutes = totalMin % 60;

    return { startDate: startDate, endDate: endDate, hours: hours, minutes: minutes };
  }

  function formatDateFR(date) {
    var days   = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
    var months = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
    return days[date.getDay()] + ' ' + date.getDate() + ' ' + months[date.getMonth()];
  }

  var DELIVERY_LAST_HTML = null;
  function buildDeliveryHTML() {
    var c = calculateDeliveryRange();
    return '<p>Commandez dans les <strong>' + c.hours + ' h ' +
           String(c.minutes).padStart(2, '0') + ' m</strong> pour être livré entre ' +
           '<strong>' + formatDateFR(c.startDate) + '</strong> et ' +
           '<strong>' + formatDateFR(c.endDate) + '</strong> en France métro.</p>';
  }

  function updateDeliveryNotes() {
    var notes = document.querySelectorAll('.delivery-note');
    if (!notes.length) return;
    if (!DELIVERY_LAST_HTML) DELIVERY_LAST_HTML = buildDeliveryHTML();
    notes.forEach(function (n) {
      if (n.dataset.inhDeliveryDone === '1') return;
      n.innerHTML = DELIVERY_LAST_HTML;
      n.dataset.inhDeliveryDone = '1';
    });
  }

  function initDeliveryCalculator() {
    updateDeliveryNotes();
    // Watch for the app to inject .delivery-note (it does so async)
    new MutationObserver(function () { updateDeliveryNotes(); })
      .observe(document.body, { childList: true, subtree: true });
    // Re-run on variant change (re-render may strip our inhDeliveryDone marker)
    var rerun = function () {
      document.querySelectorAll('.delivery-note').forEach(function (n) {
        n.dataset.inhDeliveryDone = '';
      });
      updateDeliveryNotes();
    };
    document.addEventListener('variant:change', rerun);
    document.addEventListener('product-form:variant-change', rerun);
    document.addEventListener('on:variant:change', rerun);
  }

  function init() {
    if (!getProductInfoRoot()) return; // Only on product pages
    injectStyles();
    captureMainButtonIcon();
    updateAllButtons();
    observeMutations();
    initFBTWatcher();
    initDeliveryCalculator();

    // Quantity input
    document.addEventListener('input', function (e) {
      if (e.target && e.target.name === 'quantity') scheduleUpdate();
    }, true);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'quantity') scheduleUpdate();
    }, true);

    // Quantity +/- buttons (theme uses quantity-input custom element)
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('quantity-input, .quantity__button')) {
        scheduleUpdate();
      }
    }, true);

    // Theme variant-change events (Dawn-derived themes)
    document.addEventListener('variant:change', scheduleUpdate);
    document.addEventListener('product-form:variant-change', scheduleUpdate);
    document.addEventListener('on:variant:change', scheduleUpdate);

    // Pubsub variant-change — authoritative source from product-info.js.
    // Wait for pubsub.js (it's loaded with `defer`) to expose `subscribe` and PUB_SUB_EVENTS.
    (function subscribeVariantChange() {
      if (typeof window.subscribe === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
        window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
          if (event && event.data && event.data.variant) {
            CURRENT_VARIANT = event.data.variant;
            scheduleUpdate();
          }
        });
      } else {
        setTimeout(subscribeVariantChange, 100);
      }
    })();

    // Subscription widget toggle — recompute prices when user opts in/out.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('sub-widget__checkbox')) {
        scheduleUpdate();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
